var n,e;!function(n){n.Ascending="asc",n.Descending="desc"}(n||(n={})),function(n){n.Count="count",n.IsRefined="isRefined",n.Name="name"}(e||(e={}));export{n as AlgoliaSortByDirectionEnum,e as AlgoliaSortByEnum};
